export default function ProductCard({ product }) {
  const {
    title,
    price,
    original_price,
    discount,
    orders,
    image,
    affiliate_url,
  } = product;

  return (
    <div className="card">
      <img
        className="card-img"
        src={image}
        alt={title}
        loading="lazy"
        onError={(e) => {
          e.target.src = "https://via.placeholder.com/200x190?text=No+Image";
        }}
      />
      <div className="card-body">
        <div className="card-title">{title}</div>
        <div className="price-row">
          <span className="price">${price}</span>
          {original_price && (
            <span className="original">${original_price}</span>
          )}
          {discount && (
            <span className="discount-badge">{discount} OFF</span>
          )}
        </div>
        {orders > 0 && (
          <div className="orders">{orders}+ orders</div>
        )}
        <a
          className="buy-btn"
          href={affiliate_url}
          target="_blank"
          rel="noreferrer noopener"
        >
          Buy Now
        </a>
      </div>
    </div>
  );
}
